import formats from '../../../api/formats.js'
import FieldObject from './FieldObject.js'
import store from '../../../store'
import dialogs from '../../common/dialogs'
import moment from 'moment'
import vActionForm from './ActionForm'
import profile from '../../profile/index.js'

export default
class ActionField extends FieldObject {
  getCode (model) {
    return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null
  }
  init (model) {
    this.setValue(model, null, {scheduled: null, command: this.fieldValue})
  }
  setCode (model, newCode, onChange) {
    if (!newCode) {
      // console.log('ActionField:setCode', newCode, this)
      this.setValue(model, null, {scheduled: null, command: this.fieldValue}, onChange)
    } else {
      this.setValue(model, null, newCode, onChange)
    }
  }
  calcScheduled (newObject) {
    if (!newObject.inputted) {
      return moment()
    }
    let result = moment(newObject.inputted)
    if (newObject.command) {
      let searchParams = new URLSearchParams(newObject.command.replace(/([^?]+\?)/, ''))
      result.add(searchParams.get('day-plus'), 'days')
      result.subtract(searchParams.get('day-minus'), 'days')
      if (searchParams.has('time')) {
        let time = moment(searchParams.get('time'), 'HH:mm')
        result = result.set({hour: time.get('hour'), minute: time.get('minute')})
      } else {
        result.add(searchParams.get('hour-plus'), 'hours')
        result.subtract(searchParams.get('hour-minus'), 'hours')
        result.add(searchParams.get('minute-plus'), 'minutes')
        result.subtract(searchParams.get('minute-minus'), 'minutes')
      }
      // console.log('calcScheduled', result.format('YYYY-MM-DD HH:mm'))
    }
    return result.format('YYYY-MM-DD HH:mm')
  }
  setValue (model, newCode, newObject, onChange) {
    console.log('ActionField:setValue', newCode, newObject)
    let nCode = newObject ? formats.hashCode(JSON.stringify(newObject)) : null
    if (!this.equalCode(model, nCode)) {
      if (newObject) {
        if (!newObject.logId && newObject.inputted) {
          newObject.scheduled = this.calcScheduled(newObject)
        }
        nCode = formats.hashCode(JSON.stringify(newObject))
      }
      onChange && onChange(model, this.name, nCode)
      model[this.name + '_CODE'] = nCode
      model[this.name] = nCode ? JSON.stringify(newObject) : null
      this.cxt.updateItems(model)
    }
  }
  getValue (model) {
    let jsonStr = model[this.name]
    return jsonStr ? JSON.parse(jsonStr) : {}
  }
  getDescription (model) {
    let obj = this.getValue(model)
    // console.log('getDescription', obj)
    if (!obj) {
      return ''
    }
    let time = obj.scheduled
    return time && `${formats.blank(time)}` || 'Время неопределено'
  }
  getHint (model) {
    let obj = this.getValue(model)
    if (!obj) {
      return ''
    }

    // let searchParams = new URLSearchParams(obj.command && obj.command.replace(/([^?]+\?)/, '') || '')
    let time = obj.scheduled
    let command = obj.command && obj.command.replace(/([^?]+\?)/, '') || ''
    return `Дата: ${formats.blank(time)} Команда: ${formats.blank(command)}`
  }
  open (model, onChange) {
    let value = this.getValue(model)
    Promise.resolve(value)
    .then((value) => new Promise((resolve, reject) => {
      if (!value.logId) {
        this.openForm(value).then((value) => {
          resolve(value)
        })
      } else {
        this.openAction(value).then((value) => {
          // resolve(value)
        })
      }
    }))
    .then((value) => {
      this.setValue(model, null, value, onChange)
      console.log('open', value)
      this.cxt.updateItems(model)
    })
  }
  select (model, onChange) {
    let value = this.getValue(model)
    Promise.resolve(value)
    .then((value) => new Promise((resolve, reject) => {
      if (!value) {
        this.openForm(value).then((value) => {
          resolve(value)
        })
      } else {
        this.openForm(value).then((value) => {
          resolve(value)
        })
      }
    }))
    .then((value) => {
      this.setValue(model, null, value, onChange)
      console.log('open', value)
      this.cxt.updateItems(model)
    })
  }
  openForm (value) {
    return new Promise((resolve, reject) => {
      dialogs.register('v-action-form', vActionForm)
      const onInput = (data) => {
        // console.log('openCalcForm', data)
        resolve(data)
      }
      let title = 'Действие'
      let fullscreen = store.getters.getIsMobile
      let comp = { template: `
        <v-action-form :fullscreen="fullscreen" :value="value" :title="title" v-on:input="onInput" v-on:close="$emit('close')"></v-action-form>
      `,
        data () {
          return {
            onInput: onInput,
            fullscreen: fullscreen,
            value: value,
            title: title
          }
        }
      }
      dialogs.modal(comp)
    })
  }
  openAction (item) {
    return profile.openLogAction(item.logId, this.cxt.context.getMatterId())
  }
  clearRef (model) {
    console.log('clearRef:ActionField', this)
    var refs = this.cxt.refMap.get(this.name)
    if (refs) {
      refs.forEach(r => {
        let fobj = this.cxt.fieldObjects.get(r)
        if (fobj.type === 'ACTION') {
          let obj = fobj.getValue(model)
          if (!obj.logId) {
            fobj.init(model)
            fobj.clearRef(model)
          }
        }
      })
    }
  }
  fillRef (model, data, onChange) {
    // console.log('fillRef:ActionField', data, this)
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/ActionField.js